import React, {useContext, useEffect, useState} from "react";
import "../../sass/main.scss";
import Modal from "react-modal";
import APIHelper from "../../helpers/APIHelper";
import axios2 from "../../helpers/APIHelper";
import $ from "jquery";
import Fn from "../../libraries/Fn";

const MvChangeCenter = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState();

  useEffect(() => {
    document.body.style.overflow = 'auto';
    setIsOpen(props.isOpen);
    if (!props.isOpen) props?.onClose();
  }, [props.isOpen]);

  useEffect(() => {
    if (!isOpen) props?.onClose();
  }, [isOpen]);

  const onToggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  const load = () => {
    axios2
      .post(`/member/change/center/ready?mb_no=${props.mbNo}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          setResult(result);

          const chk = (localStorage.getItem("USER.systemID") === "futureinfo" ||
              localStorage.getItem("USER.systemID") === "spoany" ||
              localStorage.getItem("USER.systemID") === "tpwls8905") ||
            Fn.getCurrentDate() >= '2024-11-01';

          if (result?.reman_pt > 0 && Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 8) {
            alert('현재 골프, 유료 G.X, P.T 등의 유료 서비스를 이용 중이므로 주센터를 변경할 수 없습니다. ');
            setIsOpen(false);
            return;
          }
          if ((result?.mm_row?.locker == "1" || result?.mm_row?.locker == "2") && Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 8) {
            alert('라커비움처리후 주센터 변경 가능합니다.');
            setIsOpen(false);
            return;
          }
          if ((result?.mm_row?.g_locker_name && result?.mm_row?.locker == "1") && Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 8) {
            alert('골프라커비움처리후 주센터 변경 가능합니다.');
            setIsOpen(false);
            return;
          }
          if (
            chk &&
            (
              result?.mm_row?.etc1_end_date >= Fn.getCurrentDate() ||
              result?.mm_row?.etc2_end_date >= Fn.getCurrentDate() ||
              result?.mm_row?.etc3_end_date >= Fn.getCurrentDate() ||
              result?.mm_row?.etc4_end_date >= Fn.getCurrentDate() ||
              result?.mm_row?.etc5_end_date >= Fn.getCurrentDate()
            )
          ) {
            alert('현재 골프, 유료 G.X, P.T 등의 유료 서비스를 이용 중이므로 주센터를 변경할 수 없습니다.');
            setIsOpen(false);
            return;
          }

          if ((localStorage.getItem("USER.systemID") === "futureinfo" ||
              localStorage.getItem("USER.systemID") === "spoany" ||
              localStorage.getItem("USER.systemID") === "testjjj" ||
              localStorage.getItem("USER.systemID") === "testst" ||
              localStorage.getItem("USER.systemID") === "tpwls8905") ||
            Fn.getCurrentDate() >= '2024-01-01'
          ) {
            if (result?.end_date >= Fn.getCurrentDate()) {
              if (result?.LL_row2?.hi_date) {
                const tMonth = new Date(result?.LL_row2?.hi_date);
                tMonth.setMonth(tMonth.getMonth() + 3);
                const afterDate = Fn.getDate(tMonth);

                if (Fn.getCurrentDate() < afterDate && Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 7) {
                  alert('최근 주센터 변경일로부터 3개월이 지나지 않아 주센터를 변경할 수 없습니다.');
                  setIsOpen(false);
                  return;
                }
              }
              {
                const monthsAgo = new Date(Fn.getCurrentDate());
                monthsAgo.setMonth(monthsAgo.getMonth() - 3);
                const beforeDate = Fn.getDate(monthsAgo);

                if ((result?.LL_row?.ap_date > beforeDate) && Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 7) {
                  alert('최근 결제한 회원권의 계약 체결일로부터 3개월이 지나지 않아 주센터를 변경할 수 없습니다.');
                  setIsOpen(false);
                  return;
                }
              }
            }
          } else {
            const monthsAgo = new Date(Fn.getCurrentDate());
            monthsAgo.setMonth(monthsAgo.getMonth() - 1);
            const beforeDate = Fn.getDate(monthsAgo);

            if (result?.LL_row?.ap_date > beforeDate && Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) <= 7) {
              alert('최근 결제한 회원권의 계약 체결일로부터 1개월이 지나지 않아 주센터를 변경할 수 없습니다.');
              setIsOpen(false);
              return;
            }
          }

          // if ($_SESSION[SystemUserAuth] >= 8 || $all_branch == "Y")
          if (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) >= 8) {
            if ($('#cc_t_branch_code').html() === '') {
              let optionsHTML = '<option value="">:선택</option>';
              result?.topList1?.forEach((list_row) => {
                optionsHTML += `<option value="${list_row.branch_code}/${list_row.branch_name}">${list_row.ho}.${list_row.branch_name}</option>`;
              });
              $('#cc_t_branch_code').html(optionsHTML);
            }
          } else {
            if ($('#cc_t_branch_code').html() === '') {
              let optionsHTML = '<option value="">:선택</option>';
              result?.topList1?.forEach((list_row) => {
                optionsHTML += `<option value="${list_row.branch_code}/${list_row.branch_name}">${list_row.branch_name}</option>`;
              });
              $('#cc_t_branch_code').html(optionsHTML);
            }
          }
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  const goSubmit = () => {
    if (!$('#cc_t_branch_code option:selected').val()) {
      alert('변경할 주센터를 선택해 주세요.');
      return;
    }

    axios2
      .postEx(`/member/change/center`, {
        auth_code: $('#auth_code').val(),
        mb_no: props.mbNo,
        receive_name: $('#_reg_step option:selected').val() || '',
        t_branch_code: $('#cc_t_branch_code option:selected').val()
      })
      .then((response) => response.json())
      .then(({code, message: data, result, pageInfo}) => {
        if (data == "ok") {
          alert('변경되었습니다');
          props?.onCallback();
          onToggleModal();
        } else if (data == "err_fran") {
          alert('주센터 변경은 직영점끼리만 가능합니다.');
        } else {
          alert('데이터오류! 시스템 관리자에게 문의하세요');
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  return (
    <Modal
      isOpen={isOpen}
      style={{
        modal: {
          backgroundColor: 'transparent',
          margin: 0,
          padding: 0,
          alignItems: undefined,
          justifyContent: undefined,
        },
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'transparent'
        }
      }}
      onAfterOpen={() => {
        Fn.centerModal();
        load();
      }}
      onRequestClose={() => setIsOpen(false)}
      ariaHideApp={false}
    >
      <div className="pop_background" style={{zIndex: 1000000000}}>
        <div className="pop_box01 p_absolute_mid_pop" style={{width: '420px'}}>
          <div className="POP_title">
            <h5><strong>주센터 변경</strong></h5>
            <p className="closed">
              <button type="button" className="btn" onClick={() => setIsOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
            </p>
          </div>

          <div className="POP_cnt_box w-100">
            <table className="view-rounded sub_view" style={{borderRadius: 0}}>
              <colgroup>
                <col width="108px"/>
                <col width="*"/>
              </colgroup>
              <tr>
                <th>지점명</th>
                <td>
                  <select className="form-select" aria-label="Default select example" style={{width: '32%'}} id="cc_t_branch_code">
                  </select>
                </td>
              </tr>
            </table>
          </div>
          <div className="text-center mb-3">
            <button type="button" className="btn btn-sm btn-point px-3 mx-1" onClick={() => goSubmit()}>변경</button>
            <button type="button" className="btn btn-sm btn-ligray px-2" onClick={() => setIsOpen(false)}>닫기</button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MvChangeCenter;
